'use client'

/*
 * Lesson markdown renderer. Bundles the heavy markdown/math stack
 * (react-markdown + remark-gfm + remark-math + rehype-katex + the KaTeX
 * stylesheet) so LessonClient can code-split it out of the lesson route's
 * first-paint JS via next/dynamic. Lessons are public + SEO-relevant and
 * server-rendered, so the dynamic import keeps ssr enabled (the deps move
 * to a lazy chunk; the rendered content + math still server-render). (#753)
 */

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css'
import { normalizeMathMarkdown } from '@/lib/render/normalize-math-markdown'

export default function MarkdownRenderer({ children }: { children: string }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} rehypePlugins={[rehypeKatex]}>
      {normalizeMathMarkdown(children)}
    </ReactMarkdown>
  )
}
